var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChildComponent } from "../../../../pages/modules/child-component";
import * as Enumerable from "linq";
import { NotificationType } from "../../../../../services/basics/notification-client.service";
var BaseTransactionVideo = /** @class */ (function (_super) {
    __extends(BaseTransactionVideo, _super);
    function BaseTransactionVideo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BaseTransactionVideo.prototype.getSessionVideo = function (recordedSessionId) {
        var _this = this;
        var global = window;
        var server = global.server;
        var inspetletApiSettings = server.inspetletApiSettings;
        var websiteId = inspetletApiSettings.WebsiteId;
        var userName = inspetletApiSettings.UserName;
        var apiKey = inspetletApiSettings.ApiKey;
        var url = 'https://api.inspectlet.com/v1/websites/' + websiteId + '/sessions';
        var sessionId = recordedSessionId;
        var data = {
            search: JSON.stringify({
                tags: {
                    tagslist: [
                        {
                            tag: "recordingSessionId",
                            value: sessionId
                        }
                    ]
                }
            })
        };
        $.ajax({
            async: true,
            type: "POST",
            url: url,
            headers: { "Authorization": "Basic " + btoa(userName + ':' + apiKey) },
            data: data,
            success: function (apiResponse) {
                if (apiResponse && apiResponse.response && apiResponse.response.sessions && apiResponse.response.sessions.length > 0) {
                    var link = Enumerable.from(apiResponse.response.sessions).firstOrDefault().sessionlink;
                    _this.iframeUrl = link.replace("http://", "https://");
                }
                else {
                    _this.notificationService.show("Video Recording", "Did not find any video recording", NotificationType.Error);
                }
            },
            error: function (apiResponse) {
                _this.notificationService.show("Video Recording", "Did not find any video recording", NotificationType.Error);
            }
        });
    };
    return BaseTransactionVideo;
}(ChildComponent));
export { BaseTransactionVideo };
